import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';

export const RecommendationsCarouselContainer = styled(Box)`
    display: flex;
    flex-grow: 1;
    flex-basis: fit-content;
    margin-top: ${spaces['1bu']};
    max-width: 836px;

    ${mediaQuery.maximum('medium')} {
        overflow: auto;
    }
`;
